
console.log('%c Halt! Who goes there?', 'color: #E9453E; font-weight: bold; font-size: 24px;');
console.log("%c I see you snooping around. Don't do anything foolish. This browser feature is meant for developers.", 'color: #3C395E; font-weight: bold; font-size: 14px;');


// Stack focus traps
var _focusTrapHandlers = [];
function focusTrapEngage(config = {}){
    /*
        Configs use one or both:
        {
            context: '.within-filter-selector',
            filter: <array of element nodes>
        }
    */
    let newHandler = {
        handle: null,
        config: config,
        lastFocused: null
    }
    // disengage last handler
    // engage a new handler, push to set
    if(typeof ally !== "undefined"){
        let handlerCount = _focusTrapHandlers.length;
        if(handlerCount > 0) {
            //stash the last focused
            _focusTrapHandlers[handlerCount - 1].lastFocused = document.activeElement;
            _focusTrapHandlers[handlerCount - 1].handle.disengage();
        }
        newHandler.handle = ally.maintain.tabFocus(newHandler.config);
        _focusTrapHandlers.push(newHandler);
    } else {
        console.error('ally.js is undefined. Unable to trap focus.');
    }
}
function focusTrapDisengage(){
    // disengage last handler, pop from array
    // re-engage previous
    if(typeof ally !== "undefined"){
        //just in case it's called erroneously
        if(_focusTrapHandlers.length > 0){
            let current = _focusTrapHandlers.pop();
            current.handle.disengage();
            //restore previous trap if exists
            let handlerCount = _focusTrapHandlers.length;
            if(handlerCount > 0) {
                let prevHandler = _focusTrapHandlers[handlerCount - 1];
                prevHandler.handle = ally.maintain.tabFocus(prevHandler.config);
                if(prevHandler.lastFocused !== null){
                    prevHandler.lastFocused.focus();
                }
            }
        }

    } else {
        console.error('ally.js is undefined. Unable to trap focus.');
    }
}

//Global general bindings
ready(function(){

    //Focus tracking for a11y
    if(typeof ally !== "undefined"){
        var focusHandle = ally.style.focusSource();
    }

    //For simple MS cases, do some UA sniffing (please use feature detection for complicated stuff)
    if( isIEorEdge() ) {
        $("body").addClass("microsoft");
    }

    //Verified Flag Explanation
    $('body').on('click','.flag--verification:not(.no--click),.verified-trigger',function(){
        httpGet(buildRoute('/verification')).then(
            function(value) {
                var $modal = buildModal(value,{
                    classes: 'modal modal--flat animated fadeIn',
                    header: 'About Organization Verification'
                });
                $('body').append($modal);
                $modal.on("modal:close",function(){
                    $modal.off("modal:close").remove();
                })
                $modal.openModal();
            }
        );
    });

    //Sub menu (not used in AS)
    $('body').on('click','.context-picker-trigger',function(){
        $('.context-picker-menu').toggleClass('is-open');
        if($('.context-picker-menu').hasClass('is-open')){
            console.log('has class!')
            $('.context-picker-menu')[0].focus();
        }
    });
    //Responsive menu open trigger when nav bars collapse TODO: get rid of jQuery
    $('body').on('click','.context-nav-trigger',function(){
        $(this).parent().find('ul').toggleClass('is-open');
    });


    //Like/Unlike TODO: turn these into self-mounting react components
    if($(this).is(".like") || $(this).is(".unlike")){
        var count = parseInt($(this).attr("data-count"));
        ($(this).is(".like")) ? count++ : count--;
        $(this).find("span").text(count);
    }

    $('body').on('click','.button--like',function(e){
        //post /portfolio/pk/follows
        e.preventDefault()
        var $this = $(this);
        var like_url = $this.attr('data-like');
        var unlike_url = $this.attr('data-unlike');
        var liked = $this.attr('data-liked') == 'true';
        var count = parseInt($this.attr('data-count'));

        if(liked){
            httpDelete(unlike_url).then(
                function(value){
                    //console.log(JSON.parse(value));
                    count--;
                    $this.attr('data-count',count);
                    $this.find('span').text(count);
                    $this.attr('data-liked','false').blur();
                })
            .catch(
                function(reason) {
                    alertify.warning('Error Trying to Unlike');
                });
        } else {
            httpPost(like_url).then(
                function(value){
                    //console.log(JSON.parse(value));
                    count++;
                    $this.attr('data-count',count);
                    $this.find('span').text(count);
                    $this.attr('data-liked','true').blur();
                })
            .catch(
                function(reason) {
                    alertify.warning('Error Trying to Like');
                });
        }

    });

    //User Subscription modal from menu
    $('body').on('click','.usersubscription-trigger', function(event){
        event.preventDefault();
        getUserSubscriptionManger($(this).attr('href'));
    });

    //Follow/Unfollow
    $('body').on('click','.bind-follow',function(e){
        //post /portfolio/pk/follows
        e.preventDefault()
        var $this = $(this);
        var url = $this.attr('href');
        if(url.indexOf("follows") == -1){
            url = url + "s";
        }

        httpPost(url, {}).then(
            function(value){
                //console.log(JSON.parse(value));
                alertify.success('User Followed');
                $this.find('i.icon-rss').removeClass("icon-rss icon--success").addClass("icon-close icon--warning");
                $this.removeClass("bind-follow").addClass("bind-unfollow").find('span').text("Stop Following");
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Start Following');
            });

    });

    $('body').on('click','.bind-unfollow',function(e){
        //delete /portfolio/pk/follow
        e.preventDefault()
        var $this = $(this);
        var url = $this.attr('href');
        if(url.indexOf("follows") != -1){
            url = url.slice(0, -1);
        }

        httpDelete(url).then(
            function(value){
                alertify.log('User Unfollowed');
                $this.find('i.icon-close').removeClass("icon-close icon--warning").addClass("icon-rss icon--success");
                $this.removeClass("bind-unfollow").addClass("bind-follow").find('span').text("Follow");
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Stop Following');
            });
    });

    FormatTimes();

    //Page hints and onboarding
    if($("*[data-hint]").length > 0 || $("*[data-intro]").length > 0) {
        $(".trigger-onboarding").addClass("is-visible").click(function(){
            introJs().start();
            introJs().showHints();
        });
    }

    CheckOnboarding();

    //Google Analytics Outbound
    document.addEventListener('click', function (event) {
        if (!event.target.matches('.ga-outbound')) return;
        if(typeof(ga) !== 'undefined'){
            event.preventDefault();
            // Log the clicked element in the console
            var url = event.target.href;
            var category = (event.target.dataset.category !== undefined) ? event.target.dataset.category : "";
            var action = (event.target.dataset.action !== undefined) ? event.target.dataset.action : "";
            var label = (event.target.dataset.label !== undefined) ? event.target.dataset.label : "";
            ga('send', 'event', {
				'eventCategory' : category,
				'eventAction' : action,
				'eventLabel' : label,
				'transport': 'beacon',
				'hitCallback': function(){
                    // document.location = url;
                    window.open(url, '_blank');
				}
			});
        } else {
            console.log("ga() called without Google Analytics.");
        }

    }, false);

    //form attribute polyfill for IE/Edge
    /*
    var supportsFormAttr = 'form' in document.createElement('button');
    if(!supportsFormAttr){
        $('button[type=submit],input[type=submit]').on('click tap', function(e){
            if ($(this).attr('form')) {
                var $form = $('#' + $(this).attr('form'));
                if($(this).parents('#' + $(this).attr('form')).length == 0) {
                    //only manually trigger if it's not inside the form already to minimize shim
                    e.preventDefault();
                    $('#' + $(this).attr('form') ).trigger('submit');
                }
            }
        });
    }
    */
    var test = $('<div><form id="form"></form><button type="submit" form="form"/></div>').appendTo('body'),
        submitted = false;
    $('form', test).on('submit', function(e){submitted = true; return false});
    $('button', test).click();
    test.remove();
    if ( ! submitted ) {
        $(document).on('click', 'button[type="submit"][form]', function(e) {
            e.preventDefault();
            $('#' + $(this).attr('form')).trigger('submit');
        })
    }

});
